/**
 * Textos de la pantalla Estadísticas (es-ES).
 */
export const metricasEs = {
  app: {
    title: 'Estadísticas',
    subtitle: '',
    infoButtonAria: 'leyenda: cómo se calculan las estadísticas',
    legendTitle: 'Leyenda',
  },
  help: {
    intro:
      'Los datos se limitan al periodo efectivo (recortado por el día de alta de la banda y por hoy).',
    modoAnio: 'Solo años civiles ya cerrados (no el año en curso).',
    modoMes: 'El mes se recorta si aún no ha terminado.',
    modoRango: '«Desde» y «Hasta» se ajustan al universo permitido para la banda.',
    comparativa:
      'La comparativa ejecuta un segundo cálculo sobre el periodo anterior inmediato (misma longitud en días civiles). Desmárcala si no la necesitas.',
    narrativa:
      'La lectura con IA resume cifras agregadas (sin exponer datos personales en el texto). Genera coste o latencia adicional.',
    fase7:
      'En la sección inferior: sedes y grupos más frecuentes, tasa de respuesta a encuestas de actuación, avales, reseñas recibidas y ranking por porcentaje de asistencia (mínimo de convocatorias para ser justo).',
  },
  wizard: {
    step: (n, total = 3) => `Paso ${n} de ${total}`,
    stepperL1: 'Periodo',
    stepperL2: 'Comparar',
    stepperL3: 'Resumen',
    step1Title: '¿Qué tipo de informe quieres generar?',
    modoAnio: 'Por año (año completo ya cerrado)',
    modoMes: 'Mensual (un mes concreto)',
    modoRango: 'Rango concreto de fechas',
    step2Title: '¿Comparar con un periodo equivalente inmediatamente anterior?',
    step2Hint:
      'Técnicamente se calcula el tramo inmediatamente previo (misma longitud en días), recortado por el alta. No es “el mismo mes del año pasado” salvo que coincida al regular periodos consecutivos.',
    step2Si: 'Sí, quiero la comparativa',
    step2No: 'No, solo el periodo actual',
    step3Title: '¿Quieres un resumen con IA que te explique los resultados agregados?',
    step3Hint: 'Sin nombres de músicos. Puede añadir latencia o coste en el servicio de IA.',
    step3Si: 'Sí, incluir resumen con IA',
    step3No: 'No, solo cifras y tablas',
    next: 'Siguiente',
    back: 'Atrás',
    consult: 'Consultar estadísticas',
    regen: 'Generar de nuevo',
  },
  informe: {
    tituloAnio: (y) => `Resumen del año ${y}`,
    tituloMes: (mesNombre, y) => `Resumen de ${mesNombre} de ${y}`,
    tituloRango: 'Resumen del periodo',
    entreFechas: (a, b) => `${a} — ${b}`,
    sinRango: 'No se pudo determinar el periodo.',
    noDatosRango: 'No hay días con datos en este periodo con los filtros actuales.',
    resumenSeccion: 'Resumen del periodo',
    resumenSeccionSub:
      'Ensayos, asistencias, actuaciones, encuestas, repertorio, archivo, plantilla y operación (sedes, grupos, avales, reseñas).',
    vistaDetalle: 'Detalle',
    vistaGraficos: 'Gráficos',
    comparativaTitulo: 'Comparativa con el periodo anterior',
    evolucionTitulo: 'Evolución y ranking',
    pdfHeaderLabel: 'Informe de estadísticas',
    pdfTitleShort: 'Estadísticas',
    pdfVistaDetalleLabel: 'Solo detalle (tablas y cifras)',
    pdfVistaGraficosLabel: 'Con gráficos (diagramas y barras)',
    pdfDescargar: 'Descargar PDF',
    pdfMenuDetalle: 'Solo detalle (tablas)',
    pdfMenuGraficos: 'Con gráficos',
    pdfGenerando: 'Generando…',
    pdfPopup: 'Permite ventanas emergentes para generar el PDF.',
    pdfError: 'No se pudo generar el informe. Inténtalo de nuevo.',
  },
  fase7: {
    cardTitle: 'Operación y confianza',
    cardSubtitle:
      'Uso de sedes y grupos, participación en encuestas, avales, reseñas y asistencia relativa a convocatorias.',
    sedesTitle: 'Sedes más usadas',
    gruposTitle: 'Grupos de ensayos más usados',
    emptySedes: 'Sin sede asignada en ensayos del periodo (o solo ensayos sin sede).',
    emptyGrupos: 'Sin grupo de ensayos (ensayos independientes u otro criterio).',
    tasaRespuestaTitle: 'Tasa de respuesta (encuestas de actuación)',
    tasaRespuestaHelp:
      'Invitaciones = filas de convocatoria a la encuesta; «con respuesta» = voto o fecha de respuesta registrada.',
    avalesTitle: 'Avales de confianza (creados en el periodo)',
    avalesEmpty: 'Ningún aval registrado con esta fecha de creación en el rango.',
    resenasTitle: 'Reseñas recibidas (creadas en el periodo)',
    resenasHelp:
      'Solo reseñas de cofradías hacia la banda. La fecha usada es la de creación de la reseña; las notas 1–5 promedian solo las reseñas en el rango.',
    resenasEmpty: 'Ninguna reseña hacia la banda con esta fecha de creación en el rango.',
    rankTasaTitle: 'Ranking por % de asistencia a ensayos',
    rankTasaHelp:
      'Solo músicos con al menos 5 convocatorias en el rango. Tasa = presentes / convocatorias.',
    rankTasaEmpty:
      'No hay músicos con el mínimo de convocatorias para este ranking en el periodo.',
  },
  wrapped: {
    pageTitle: 'Resumen en cifras | Cadencya',
    cta: 'Resumen animado',
    ctaHelp: 'Abre una página a pantalla completa para compartir, con el mismo periodo e IA.',
    noToken: 'Falta el enlace (parámetro t). Pide a la banda un enlace de compartir válido.',
    loadError: 'No se pudo cargar el resumen. El enlace puede haber caducado o no ser válido.',
    noData: 'No hay datos en este periodo; el creador del enlace puede ajustar fechas o filtros en Estadísticas.',
    titleGeneric: 'Tu resumen de estadísticas',
    subYear: 'Un año, muchas historias',
    subRange: 'Tus cifras en un vistazo',
    welcomeYear: (y) => `Bienvenido a tu resumen de ${y}`,
    welcomeMonth: (mes, y) => `Tu resumen de ${mes} de ${y}`,
    keepScrolling: 'Sigue bajando',
    sectionNumbers: 'Los números no mienten',
    sectionIa: 'Lectura del periodo',
    sectionComparativa: 'Antes vs ahora',
    ensayos: 'Ensayos con fecha en el rango',
    horas: 'Horas de ensayo (con hora de fin)',
    actu: 'Actuaciones con fecha',
    asis: 'Registros de asist. (músico × ensayo)',
    tasa: 'Tasa de presente sobre asist. cerrada',
    footer: 'Hecho con',
    disfruta: 'Gracias por tocar con Cadencya',
    /** Textos de “historias” al hacer scroll (estilo Spotify Wrapped) */
    story: {
      kickerIa: 'Lectura con IA',
      explIa:
        'Resumen en palabras, sin nombres de músicos: solo cifras agregadas. Si no hay texto, el periodo aplica igual; puede faltar clave de IA o haber un error temporal.',
      kickerCifras: 'Tus cifras',
      explCifras: 'Ahora entramos al detalle: ensayos, asistencia y actuaciones con fecha en el rango. Nada de humo, solo acumulado con sello de fecha.',
      kickerEnsayos: 'Ensayos',
      explEnsayos:
        'Cada ensayo con fecha en el rango cuenta. Horas de preparación, estados (programado, hecho, cancelado) y dónde se concentra el tiempo de sala.',
      kickerAsis: 'Asistencia a ensayos',
      explAsis:
        'Registros de músico por ensayo: cuánta convocatoria, cuánta presencia, y el porcentaje de presente sobre asistencia ya cerrada (no pendiente).',
      kickerActu: 'Actuaciones',
      explActu:
        'Citas con fecha: pasos de borrador a archivo. Los estados resumen dónde va cada compromiso. Si es el verano de la banda, que se vea en el dato.',
      kickerRepertorio: 'Repertorio en actuaciones',
      explRepertorio:
        'Cada obra en un programa de actuación cuenta una vez. Autores, apariciones y obras con más salida en el tramo. Marchas y catálogo, cuando aplica.',
      kickerEncuestas: 'Encuestas a músicos',
      explEncuestas:
        'Tras actuación: viste, no vino, o sin contestar. Y la tasa de respuesta real frente a invitaciones, para medir voz y participación.',
      kickerArchivo: 'Archivo de partituras',
      explArchivo:
        'Qué obras o páginas nacieron (fecha de creación) en el periodo, no el día del concierto. Crecimiento del fondo a tu ritmo de digitación o subida.',
      kickerPlantilla: 'Plantilla en ensayos',
      explPlantilla:
        'Músicos en plantilla, cuántos al menos con un “Presente” y el porcentaje de quienes dejaron huella mínima en asistencia en el rango. Equipo, presente o no presente todavía.',
      kickerOperacion: 'Operación y dónde ensayáis',
      explOperacion:
        'Sedes y grupos de ensayos que más asoman. Luego, avales y reseñas: confianza y valoración en la ventana de fechas que elegiste.',
      kickerSedes: 'Dónde ensayáis',
      explSedes: 'Frecuencia por sede. Si todavía vais de ensayo en ensayo, aquí se ve dónde se os da más el aire acondicionado o el eco.',
      kickerGrupos: 'Cómo agrupáis los ensayos',
      explGrupos: 'Grupos de ensayos: qué pesa más al repartir convocatorias en el rango. Independientes también cuentan.',
      kickerAvales: 'Avales de confianza',
      explAvales:
        'Creados en el periodo: cuánto confiar en quién, y en qué estado (pendiente, aceptado, rechazado). La colaboración pasa por aquí, un aval detrás de otro.',
      kickerResenas: 'Reseñas de cofradías',
      explResenas:
        'Hacia la banda: notas 1 a 5 en comunicación, puntualidad, calidad, general. Año raro o año redondo, las medias lo cuentan; sin nombres de cofradía en cifra agregada.',
      kickerComparativa: 'Antes vs ahora',
      explComparativa:
        'Mismo tramo de días, desplazado hacia el pasado: el periodo inmediatamente anterior. Variación y contexto, sin magia, solo doble lectura de los mismos KPI.',
      kickerEvolucion: 'Evolución y ranking',
      explEvolucion:
        'Mes a mes, ensayos y actuaciones. Ranking de “presente” a ensayos y, si aplica, tasa mínima de convocatorias para juzgar asistencia con justicia.',
    },
  },
};
